import type { DraftLength, DraftTone } from "./DraftMessagePanel";
import "./AiDraftMessage.scss";

export const TONE_OPTIONS: { value: DraftTone; messageId: string }[] = [
  { value: "casual", messageId: "app.toolboxChat.draftMessage.tone.casual" },
  { value: "professional", messageId: "app.toolboxChat.draftMessage.tone.professional" },
];

export const LENGTH_OPTIONS: { value: DraftLength; messageId: string }[] = [
  { value: "brief", messageId: "app.toolboxChat.draftMessage.length.brief" },
  { value: "standard", messageId: "app.toolboxChat.draftMessage.length.standard" },
  { value: "detailed", messageId: "app.toolboxChat.draftMessage.length.detailed" },
];

export const PillCheckIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    aria-hidden="true"
    viewBox="0 0 12 10"
    width="12"
    height="10"
    fill="none"
  >
    <path
      d="M1 5l3.5 3.5L11 1"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export function PillGroup<T extends string>({
  options,
  selected,
  name,
  labelId,
  onSelect,
}: {
  options: { value: T; label: string }[];
  selected: T;
  name: string;
  labelId: string;
  onSelect: (value: T) => void;
}) {
  return (
    <div className="draft-pill-group" role="radiogroup" aria-labelledby={labelId}>
      {options.map(({ value, label }) => (
        <label
          key={value}
          htmlFor={`${name}-${value}`}
          className={`draft-pill${selected === value ? " draft-pill--selected" : ""}`}
        >
          <input
            type="radio"
            id={`${name}-${value}`}
            name={name}
            value={value}
            checked={selected === value}
            onChange={() => onSelect(value)}
            className="draft-pill-input"
          />
          {selected === value && <PillCheckIcon className="draft-pill-check" />}
          {label}
        </label>
      ))}
    </div>
  );
}
